
/* eslint-disable */
import dayjs from "dayjs";
import {
    ElForm,
    ElRow,
    ElCol,
    ElFormItem,
    ElInput,
    ElInputNumber,
    ElRadioGroup,
    ElRadio,
    ElCheckboxGroup,
    ElCheckbox,
    ElSelect,
    ElCascader,
    ElSwitch,
    ElDatePicker,
    ElOption,
} from "element-plus";
import { defineComponent, h, reactive, ref, watchEffect } from "vue";
export default defineComponent({
    props: {
        value: {
            type: Object,
            default: () => {
                return {};
            },
        },
        model: {
            type: Object,
            default: () => {
                return {};
            },
        },
        rules: {
            type: Object,
            default: () => {
                return {};
            },
        },
        source: {
            type: Object,
            default: () => {
                return {};
            },
        },
        labelPosition: {
            type: String,
            default: "top",
        },
        size: {
            type: String,
            default: "small",
        },
        columns: {
            type: Array,
            default: () => [],
        },
        gutter: {
            type: Number,
            default: 20,
        },
        columnsNumber: {
            type: Number,
            default: 4,
        },
        filterColumns: {
            type: Array,
            default: () => [],
        },
        filterRrules: {
            type: Array,
            default: () => [],
        },
        disabledColumns: {
            type: Array,
            default: () => [],
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any, { emit, slots }) {
        const form: any = reactive({
            slots,
            columns: [],
        });

        watchEffect(() => {
            let layoutColumnsMultiple: any = [];
            let layoutColumnsMultipleGridsSum = 0;

            const { filterColumns = [], columns = [] } = props;
            const layoutColumns = columns.filter((cell: any) => !filterColumns.includes(cell.key));

            layoutColumns.map((cell: any) => {
                const {
                    span = props.columnsNumber == 3 ? 8 : 6,
                    offset = 0,
                    push = 0,
                    pull = 0,
                } = cell;

                layoutColumnsMultipleGridsSum += [span, offset, push, pull].reduce(function (
                    prev: number,
                    curr: number
                ) {
                    return prev + curr;
                });

                if (layoutColumnsMultipleGridsSum >= 24) {
                    layoutColumnsMultipleGridsSum = 0;
                }
                Array.isArray(layoutColumnsMultiple[layoutColumnsMultiple.length - 1])
                    ? layoutColumnsMultiple[layoutColumnsMultiple.length - 1].push(cell)
                    : layoutColumnsMultiple.push([cell]);
            });

            form.columns = layoutColumnsMultiple;
        });

        const RenderTypeMethod = (cell: any) => {
            const style = {
                width: "100%",
            };

            const {
                type,
                label = "",
                field,
                key,
                span = props.columnsNumber == 3 ? 8 : 6,
                offset = 0,
                push = 0,
                pull = 0,
                slots = {},
                events = {},
                bind = {},
            } = cell;

            const rules = props.filterRrules.includes(key) ? [] : cell.rules || [];
            const disabled = props.disabled || cell.disabled || props.disabledColumns.includes(key);
            const cellProps = cell.props || {
                value: "value",
                disabled: "disabled",
                label: "label",
            };
            return (
                <ElCol span={span} offset={offset} push={push} pull={pull}>
                    <ElFormItem label={label} prop={field} rules={rules} key={key}>
                        {() => {
                            switch (type) {
                                case "el-input": {
                                    const { placeholder = "请输入" } = cell;
                                    return (
                                        <ElInput
                                            v-model={[props.value[field], "modelValue"]}
                                            clearable={true}
                                            placeholder={placeholder}
                                            disabled={disabled}
                                            onBlur={events.blur}
                                            onFocus={events.focus}
                                            onChange={events.change}
                                            onInput={events.input}
                                            onClear={events.clear}
                                            {...bind}
                                        >
                                            {{
                                                prepend: slots.prepend,
                                                append: slots.append,
                                            }}
                                        </ElInput>
                                    );
                                }

                                case "el-input-number": {
                                    const { placeholder = "请输入数字类型" } = cell;
                                    return (
                                        <ElInputNumber
                                            style={style}
                                            v-model={[props.value[field], "modelValue"]}
                                            disabled={disabled}
                                            onChange={events.change}
                                            onInput={events.input}
                                            onFocus={events.focus}
                                            placeholder={placeholder}
                                            {...bind}
                                        ></ElInputNumber>
                                    );
                                }

                                case "el-radio": {
                                    return (
                                        <ElRadioGroup v-model={[props.value[field], "modelValue"]} disabled={disabled} onChange={events.change}>
                                            {Array.isArray(props.source[field]) &&
                                                props.source[field].map((data: any) => {
                                                    return (
                                                        <ElRadio
                                                            label={data[cellProps.value]}
                                                            disabled={data[cellProps.disabled]}
                                                        >
                                                            {data[cellProps.label]}
                                                        </ElRadio>
                                                    );
                                                })}
                                        </ElRadioGroup>
                                    );
                                }

                                case "el-checkbox": {
                                    return (
                                        <ElCheckboxGroup
                                            v-model={[props.value[field], "modelValue"]}
                                        >
                                            {Array.isArray(props.source[field]) &&
                                                props.source[field].map((data: any) => {
                                                    return (
                                                        <ElCheckbox
                                                            label={data[cellProps.value]}
                                                            disabled={data[cellProps.disabled]}
                                                        >
                                                            {data[cellProps.label]}
                                                        </ElCheckbox>
                                                    );
                                                })}
                                        </ElCheckboxGroup>
                                    );
                                }

                                case "el-select": {
                                    const { placeholder = "请选择" } = cell;
                                    const cellKey = Math.random().toString(36).substr(-8);
                                    const options = Array.isArray(props.source[field])
                                        ? props.source[field].map((data: any) => {
                                            return {
                                                value: data[cellProps.value],
                                                label: data[cellProps.label],
                                                disabled: data[cellProps.disabled],
                                            };
                                        })
                                        : [];
                                    return (
                                        <ElSelect
                                            key={key}
                                            disabled={disabled}
                                            v-model={[props.value[field], "modelValue"]}
                                            clearable
                                            style={style}
                                            filterable
                                            placeholder={placeholder}
                                            onChange={events.change}
                                            onClear={events.clear}
                                            onBlur={events.blur}
                                            onFocus={events.focus}
                                            onremove-tag={events.removeTag}
                                            {...bind}
                                        >
                                            {options.map((cell: any) => {
                                                return (
                                                    <ElOption
                                                        key={cell.value}
                                                        value={cell.value}
                                                        label={cell.label}
                                                        disabled={cell.disabled}
                                                    ></ElOption>
                                                );
                                            })}
                                        </ElSelect>
                                    );
                                }

                                case "el-cascader": {
                                    const { placeholder = "请选择" } = cell;
                                    const options = Array.isArray(props.source[field])
                                        ? props.source[field]
                                        : [];
                                    return (
                                        <ElCascader
                                            v-model={[props.value[field], "modelValue"]}
                                            style={style}
                                            disabled={disabled}
                                            options={options}
                                            props={cellProps}
                                            placeholder={placeholder}
                                            onChange={events.change}
                                            onexpand-change={events.expandChange}
                                            onBlur={events.blur}
                                            onFocus={events.focus}
                                            onvisible-change={events.visibleChange}
                                            onremove-tag={events.removeTag}
                                            {...bind}
                                        ></ElCascader>
                                    );
                                }

                                case "el-switch": {
                                    return (
                                        <ElSwitch
                                            v-model={[props.value[field], "modelValue"]}
                                            disabled={disabled}
                                            {...bind}
                                            onChnage={events.change}
                                        ></ElSwitch>
                                    );
                                }

                                case "el-date-picker": {
                                    const {
                                        startPlaceholder = "开始日期",
                                        endPlaceholder = "结束日期",
                                        placeholder = "选择日期",
                                    } = cell;

                                    const datePickerChnage = (value: any) => {
                                        const { type = "date" } = bind;
                                        const { field } = cell;

                                        if (typeof events.change == "function") {
                                            props.value[field] = events.change(value, cell);
                                            return;
                                        }

                                        switch (type) {
                                            case "date": {
                                                value
                                                    ? (props.value[field] = dayjs(value).format(
                                                        "YYYY-MM-DD"
                                                    ))
                                                    : false;
                                                return;
                                            }

                                            case "month": {
                                                value
                                                    ? (props.value[field] = dayjs(value).format(
                                                        "YYYY-MM"
                                                    ))
                                                    : false;
                                                return;
                                            }

                                            case "daterange": {
                                                value
                                                    ? (props.value[field] = [
                                                        dayjs(value[0]).format("YYYY-MM-DD"),
                                                        dayjs(value[1]).format("YYYY-MM-DD"),
                                                    ])
                                                    : false;
                                                return;
                                            }

                                            case "datetimerange": {
                                                value
                                                    ? (props.value[field] = [
                                                        dayjs(value[0]).format(
                                                            "YYYY-MM-DD HH:mm:ss"
                                                        ),
                                                        dayjs(value[1]).format(
                                                            "YYYY-MM-DD HH:mm:ss"
                                                        ),
                                                    ])
                                                    : false;
                                                return;
                                            }
                                        }
                                    };
                                    return (
                                        <ElDatePicker
                                            v-model={[props.value[field], "modelValue"]}
                                            disabled={disabled}
                                            onChange={(value: any) => datePickerChnage(value)}
                                            onBlur={events.blur}
                                            onFocus={events.focus}
                                            startPlaceholder={startPlaceholder}
                                            endPlaceholder={endPlaceholder}
                                            placeholder={placeholder}
                                            style={style}
                                            {...bind}
                                        ></ElDatePicker>
                                    );
                                }
                            }
                        }}
                    </ElFormItem>
                </ElCol>
            );
        };

        const RenderFormCell = (cell: any) => {
            const {
                span = props.columnsNumber == 3 ? 8 : 6,
                offset = 0,
                push = 0,
                pull = 0,
                label,
                field,
                rules,
                key,
            } = cell;
            if (cell.slot) {
                return (
                    <ElCol span={span} offset={offset} push={push} pull={pull}>
                        {
                            // @ts-ignore
                            form.slots[cell.slot] && form.slots[cell.slot]()
                        }
                    </ElCol>
                );
            } else if (typeof cell.render == "function") {
                return (
                    <ElCol span={span} offset={offset} push={push} pull={pull}>
                        <ElFormItem label={label} prop={field} rules={rules} key={key}>
                            {cell.render()}
                        </ElFormItem>
                    </ElCol>
                );
            }
            return RenderTypeMethod(cell);
        };

        const RenderFormColumns = () => {
            return (
                <>
                    {form.columns.map((col: any) => {
                        return (
                            <ElRow gutter={props.gutter}>
                                {col.map((cell: any) => {
                                    return RenderFormCell(cell);
                                })}
                            </ElRow>
                        );
                    })}
                </>
            );
        };

        const renader = (
            <ElForm
                disabled={props.disabled}
                model={props.value}
                size={props.size}
                labelPosition={props.labelPosition}
            >
                <RenderFormColumns></RenderFormColumns>
            </ElForm>
        );

        return { renader };
    },

    render() {
        return h(this.renader, { ref: "validateForm" });
    },

    methods: {
        validate() {
            return new Promise((resolve, reject) => {
                // @ts-ignore
                this.$refs.validateForm.validate((valid: any) => {
                    if (valid) {
                        resolve(true);
                    } else {
                        reject(false);
                    }
                });
            });
        },
        clearValidate() {
            // @ts-ignore
            this.$refs.validateForm.clearValidate();
        },
    },
});
